<template>
    <g :id="`object${metadata.id}`" 
        :style="{ 'opacity': width===0 ? 0 : 1 }"
        :class="{
            'object': true,
            'locked': metadata.options.locked,
            'dragging': dragging,
            'disabled':  objectMode == 1 || objectMode == 2 || config.disableHoverFilter,
            'passthrough': objectMode == 2
        }" ref="group" :transform="`translate(${absolutePos.x} ${absolutePos.y}) scale(${flipScale}, 1)`" @mousedown="startDrag" @touchstart="startDrag" @contextmenu="contextMenu">
        <!--<component v-if="component != undefined" :is="component"></component>-->
        <!--<Test/>-->
        <g :transform="`rotate(${metadata.options.rotation*flipScale}) translate(${-width/2}, ${-height/2})`">
            <image v-if="metadata.svg != undefined && width > 0" :href="metadata.svg" :xlink:href="metadata.svg" :width="width" :height="height"></image>
            <component v-if="component != undefined" :is="component" :metadata="metadata"></component>
            <foreignObject v-if="metadata.webm != undefined" x="0" y="0" :width="width" :height="height">
                <video ref="image" autoplay loop :width="width" :height="height">
                    <source :src="metadata.webm" type="video/webm">
                </video>
            </foreignObject>
            <!--<foreignObject :transform="`translate(${-bbox.width/2}, ${-bbox.height/2})`" v-if="metadata.svg != undefined" :width="bbox.width||1" :height="bbox.height||1">
                <img class="noselect" ref="image" :src="metadata.svg" @load="fixSize" />
            </foreignObject>-->
            <!--<component v-if="component != undefined" :is="component"></component>-->
            
        </g>
        
        <foreignObject v-if="showContextMenu" class="contextmenu">
            <div class="panel"></div>
        </foreignObject>
    </g>
</template>

<script>
import { mapGetters } from "vuex";
import { angle, distance, getSVGCoordinates, calculateRelativePosition, getItemByValue } from "@/utils";

//import Text from "./custom/Text";

//import Test from "@/components/objects/Test";

let dragging = {
    id: null,
    start: {
        mouse: null,
        pos: null
    }
}

//let sizes = {}

export default {
    name: 'Object',
    props: ['metadata', 'identity'],
    data() {
        return {
            /*dragging: false,
            start: {
                mouse: null,
                pos: null,
            },*/
            dragging: false,
            width: 0,
            height: 0,

            component: null,
            config: {
                disableHoverFilter: false
            }
        };
    },
    computed: {
        ...mapGetters(["getSelf", "menu", "objectMode", "getRooms"]),
        showContextMenu() {
            return this.menu === this.metadata.id;
        },
        /*bbox() {
            // updatebbox gets incremented to make this property reactive...
            let _ = this.updateBBox; // this is incredibly stupid...

            return sizes[this.metadata.id] || {x:0,y:0,width:0,height:0};
        },*/
        flipScale() {
            return this.metadata.options.flip ? -1 : 1;
        },
        absolutePos() {
            /*let room = getItemByValue(this.getRooms, 'id', this.metadata.in) || {x: 0, y: 0};
            console.log("IN", this.metadata.in, room);
            return {
                x: this.metadata.x + room.x,
                y: this.metadata.y + room.y
            }*/
            return calculateRelativePosition(this.metadata, this.getRooms);
        }
    },
    mounted() {
        window.addEventListener('mousemove', this.mouseMove);
        window.addEventListener('touchmove', this.mouseMove);
        window.addEventListener('mouseup', this.endDrag);
        window.addEventListener('touchend', this.endDrag);

        if(this.metadata.svg) {
            //TODO: make width+height be mandatory in JSON file defining objects

            let image = new Image();

            image.addEventListener('load', (() => {
                this.width = image.width;
                this.height = image.height;
            }).bind(this), false);

            image.src = this.metadata.svg;
        }

        if(this.metadata.component) {
            import('./custom/' + this.metadata.component).then((module => {
                let component = module.default;
                this.config = component.CONFIG || {};
                this.component = component;
                this.width = 200;
            }).bind(this))
            
        }

        if(this.metadata.width) {
            this.width = this.metadata.width;
        }
        
        if(this.metadata.height) {
            this.height = this.metadata.height;
        }

        
        //component.$parent = null;
        /*let mounted = component.mounted;
        component.mounted = () => {
            delete this.$store
            delete this.$parent

            console.log(this);

            if(typeof mounted == 'function') mounted()
        }

        this.component = component;*/


        //delete this.component.$store
        //delete this.component.$parent

        //window.addEventListener('keydown', this.keyDown);

        //this.component = import('@/../public/Test.vue');
        //console.log(this.component);
    },
    methods: {
        /*fixSize() {
            this.bbox = (this.$refs.image || this.$refs.group).getBoundingClientRect();
            console.log("BBOX", this.bbox);

            console.log('BBOX (fixed)', (this.$refs.image || this.$refs.group).getBBox())
        },*/
        mouseMove(e) {
            if(dragging.id === this.metadata.id) {
                //this.dragging = true;

                let leftMouseButtonOnlyDown = (e.buttons === undefined ? e.which === 1 : e.buttons === 1) || e.touches != undefined;

                // if user right clicks or gets stuck in dragging, this fixes it
                if(!leftMouseButtonOnlyDown) {
                    this.endDrag();
                    return;
                }

                var cursorpt = getSVGCoordinates(e);

                if(dragging.start.mouse == undefined) {
                    dragging.start.pos = {x: this.absolutePos.x, y: this.absolutePos.y }
                    dragging.start.mouse = cursorpt;
                } else {
                    let absoluteX = cursorpt.x - dragging.start.mouse.x + dragging.start.pos.x;
                    let absoluteY = cursorpt.y - dragging.start.mouse.y + dragging.start.pos.y;
                    this.$store.dispatch('updateObjectProps', [
                        { id: this.metadata.id, prop: 'x', value: absoluteX },
                        { id: this.metadata.id, prop: 'y', value: absoluteY  },
                        { id: this.metadata.id, prop: 'z_index', value: Date.now() }
                    ]);

                    let inside, insidePos;
                    this.getRooms.forEach(room => {
                        let roomPos = calculateRelativePosition(room, this.getRooms);

                        if(absoluteX > roomPos.x && absoluteX < roomPos.x + room.width && absoluteY > roomPos.y && absoluteY < roomPos.y + room.height) {
                            inside = room.id;
                            insidePos = roomPos;
                        }
                    });

                    //console.log('IN', inside);

                    if(inside != undefined) {
                        let relativeX = absoluteX - insidePos.x;
                        let relativeY = absoluteY - insidePos.y;
                        this.$store.dispatch('updateObjectProps', [
                            { id: this.metadata.id, prop: 'relx', value: relativeX },
                            { id: this.metadata.id, prop: 'rely', value: relativeY  },
                            { id: this.metadata.id, prop: 'in', value: inside }
                        ]);
                    } else {
                        this.$store.dispatch('updateObjectProps', [
                            { id: this.metadata.id, prop: 'relx', value: null },
                            { id: this.metadata.id, prop: 'rely', value: null  },
                            { id: this.metadata.id, prop: 'in', value: null }
                        ]);
                    }
                    

                    let pointerAngle = angle(this.getSelf, cursorpt);
                    let pointerDistance = distance(this.getSelf, cursorpt);
                    
                    this.$store.dispatch('updatePointer', {
                        type: 'hold',
                        distance: pointerDistance,
                        angle: pointerAngle
                    });
                }
            } else {
                this.dragging = false;
            }
            
        },
        startDrag(e) {
            if(this.metadata.options.locked || this.objectMode > 0 || this.metadata.dragging) return

            dragging.id = this.metadata.id;

            this.$store.dispatch('updateObjectProps', [
                { id: this.metadata.id, prop: 'dragging', value: true }
            ]);

            e.preventDefault();
            return false
        },
        endDrag() {
            if(dragging.id === this.metadata.id) {
                dragging.id = null;
                this.$store.dispatch('updatePointer', null);
                this.$store.dispatch('updateObjectProps', [
                    { id: this.metadata.id, prop: 'dragging', value: false }
                ]);

                dragging.start.pos = null;
                dragging.start.mouse = null;
            }

        },
        /*keyDown(e) {
            // delete key to destroy object
            
            if(this.dragging == true && e.keyCode == 8) {
                console.log(this.metadata.type, this.metadata.id, this.identity, this.metadata.id == this.identity);
                //console.log(this.metadata.id)
                this.$store.dispatch('destroyObject', this.metadata.id);
            }
        },*/

        contextMenu(e) {
            e.preventDefault();

            //menu.id = this.metadata.id;
            this.$store.dispatch('createContextMenu', {
                pos: getSVGCoordinates(e),
                for: this.metadata
            });
        }
    },
    /*components: {
        Test
    }*/
};
</script>

<style>
    .object:not(.locked):not(.disabled) {
        cursor: grab;
    }
    .object:not(.locked):not(.disabled).dragging {
        cursor: grabbing;
    }

    .object:not(.locked):not(.disabled):hover {
        /*filter: url(#select);*/
        filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.5));
        filter: url(#select);
        /*filter: saturate(1) brightness(1.5);*/
    }

    .object {
        opacity: 1;
    }
    .passthrough {
        opacity: 0.4 !important;
        pointer-events: none;
    }

    /*.object > g {
        transition: all .1s ease-out;
        transition-delay: .02s;
    }*/
    .object {
        transition: opacity .2s ease-out;
    }
</style>